import { Component, inject, signal, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbstractPageComponent, BasePageComponent } from '@spike/scaffolds';
import { ResourceApiService, AsyncApiService } from '@spike/core';
import { MonthlyRecap } from '../../models/monthly-recap.model';
import { Wallet } from '../../models/wallet.model';
import { FinancialUtilityService } from '../../services/utility/financial-utility.service';
import { TradeMonthlyRecapTableComponent } from "../../components/trade-monthly-recap-table/trade-monthly-recap-table";
import { ButtonModule } from 'primeng/button';
import { ChartModule } from 'primeng/chart';
import { DrawerModule } from 'primeng/drawer';
import { EntityApiEnum } from 'src/app/config/entity-api.enum';
import { WalletBarChartComponent } from '../../components/wallet-bar-chart/wallet-bar-chart';

@Component({
  selector: 'spike-wallet-histoy-page',
  standalone: true,
  imports: [CommonModule, TradeMonthlyRecapTableComponent, ButtonModule, ChartModule, DrawerModule, BasePageComponent, WalletBarChartComponent],
  templateUrl: './wallet-history-page.html',
})
export class WalletHistoryPageComponent extends AbstractPageComponent {
  private readonly resourceApi = inject(ResourceApiService);

  public readonly breadcrumb = [{ label: 'Progressione Patrimoniale' }];
  
  // Signals per lo stato UI
  public year = signal<number>(new Date().getFullYear());
  public view = signal<'table' | 'chart'>('table');
  public isDetailVisible = signal(false);
  public detailItems = signal<any[]>([]);

  // Risorse API
  public readonly walletsResource = this.resourceApi.selectAll<Wallet>(signal(EntityApiEnum.FIN_WALLET));
  public readonly progressionLiqResource = this.resourceApi.selectAll<MonthlyRecap>(signal(EntityApiEnum.FIN_WALLET_RECAP_PROGRESSION_LIQ));
  public readonly progressionInvResource = this.resourceApi.selectAll<MonthlyRecap>(signal(EntityApiEnum.FIN_WALLET_RECAP_PROGRESSION_INV));

  // Computed per il filtraggio e l'arricchimento
  public readonly walletProgressListLiq = computed(() => this.filterAndEnrich(this.progressionLiqResource.value()));
  public readonly walletProgressListInv = computed(() => this.filterAndEnrich(this.progressionInvResource.value()));

  public readonly yearProgressTotalList = computed(() => {
    const total = FinancialUtilityService.getTotal([...this.walletProgressListLiq(), ...this.walletProgressListInv()]);
    total.shortDescription = 'GRAND TOTAL';
    total.isBoldRow = true;
    return [total];
  });

 

  private filterAndEnrich(list: MonthlyRecap[]): MonthlyRecap[] {
    const currentYear = this.year();
    const wallets = this.walletsResource.value();
    return list
      .filter(x => x.accountingYear === currentYear)
      .map(item => ({
        ...item,
        shortDescription: wallets.find(w => w.finWalletId === item.finWalletId)?.shortDescription || 'N/D'
      }))
      .sort((a, b) => a.shortDescription.localeCompare(b.shortDescription));
  }

  // Navigazione
  pagePrev() { this.year.update(y => y - 1); }
  pageNext() { this.year.update(y => y + 1); }

  openDetail(event: any) {
    // Logica di caricamento dettaglio se necessaria
    this.isDetailVisible.set(true);
  }

  
}